module.exports = __webpack_public_path__ + "static/profil_pic_2-5c608ec960f511653a2a4fc86d49c86f.jpg";